import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	start: {
		id: 'servicedesk-sla-settings.common.conditions.condition-header.start',
		defaultMessage: 'Start counting time when...',
		description: 'label for start condition',
	},
	pause: {
		id: 'servicedesk-sla-settings.common.conditions.condition-header.pause',
		defaultMessage: 'Pause counting time during...',
		description: 'label for pause condition',
	},
	stop: {
		id: 'servicedesk-sla-settings.common.conditions.condition-header.stop',
		defaultMessage: 'Finish counting time when...',
		description: 'label for stop condition',
	},
});
